import React from "react";
import useAppContext from "state/AppContext";

export default function JobPostingVideo(props) {
  const appContext = useAppContext();
  const { jobPostingVideo } = appContext.selectedOrder.videos;

  return (
    <div className="flex items-center justify-center mb-6">
      <iframe
        allowFullScreen
        src={jobPostingVideo.url}
        title={jobPostingVideo.title}
        className="w-[600px] h-[400px] rounded-2xl"
      ></iframe>
    </div>
  );
}
